function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZohoInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 268,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeff",
      stroke: "none"
    },
    d: "M0 0L0 223L1 223C2.97589 177.68 49.4231 136.622 81 109.579C99.1302 94.0524 124.876 77.0036 127 51L74 51C57.3934 51 35.9051 54.5063 21 45.6474C5.10331 36.1991 6.24707 14.1483 22.0008 5.34875C33.5427 -1.09824 48.292 1 61 1L132 1C143.855 1 157.834 -0.920135 169 3.8804C180.271 8.72629 183.837 20.5485 183.981 32C184.617 82.4438 148.766 118.375 114 149.83C93.0191 168.813 69.1376 189.248 58 216C89.5564 216 123.772 212.279 155 216.729C167.979 218.579 182.729 221.62 187 236L188 236L188 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M33 1L33 2L36 2L33 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M36 1L37 2L36 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M37 1L38 2L37 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf0132",
      stroke: "none"
    },
    d: "M127 50C126.78 76.2487 97.8516 95.0307 80 110.424C47.432 138.506 7.18568 175.649 1.28935 221C-0.191372 232.389 -1.57459 251.275 8.10494 259.606C17.4796 267.675 37.2913 266.995 49 267L134 267C147.74 267 165.839 268.045 177.985 260.521C191.966 251.86 189.811 229.996 176 222.417C158.887 213.025 133.757 217 115 217L58 217C63.8039 195.95 84.1532 178.847 99 164C135.344 127.656 177.56 97.1535 182.83 42C183.922 30.5785 184.357 14.1156 173.985 6.64893C163.85 -0.646606 147.787 1 136 1L59 1C46.3391 1 31.3013 -0.421417 20.0039 6.47919C6.08451 14.9813 6.74292 37.7486 21 45.5833C35.8867 53.764 57.6204 50 74 50L127 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M155 1L156 2L155 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M156.667 1.33334L157.333 1.66666L156.667 1.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M158.667 1.33334L159.333 1.66666L158.667 1.33334M28.6667 2.33334L29.3333 2.66666L28.6667 2.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M30 2L31 3L30 2M163.667 2.33334L164.333 2.66666L163.667 2.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M165 2L166 3L165 2M25 3L26 4L25 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M26 3L27 4L26 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M167 3L168 4L167 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M168 3L169 4L168 3M23 4L24 5L23 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M170 4L171 5L170 4M21 5L22 6L21 5M172 5L173 6L172 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M19 6L20 7L19 6M174 6L175 7L174 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M18 7L19 8L18 7M175 7L176 8L175 7M176 8L177 9L176 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M15 9L16 10L15 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M177 9L178 10L177 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M178 10L179 11L178 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M13 12L14 13L13 12M179 12L180 13L179 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M12 13L13 14L12 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M180 14L181 15L180 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M11 15L12 16L11 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M11 16L12 17L11 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M181 16L182 17L181 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M181 17L182 18L181 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M10 18L11 19L10 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M10 19L11 20L10 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M10 20L11 21L10 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M182 20L183 21L182 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M182 21L183 22L182 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M182 22L183 23L182 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M9 23L9 30L10 30L9 23M183 26L183 39L184 39L183 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M10 32L11 33L10 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M10 33L11 34L10 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M11 35L12 36L11 35M12 37L13 38L12 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M13 39L14 40L13 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M14 40L15 41L14 40M15 41L16 42L15 41M16 42L17 43L16 42M17 43L18 44L17 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M18 44L19 45L18 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M182 44L183 45L182 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M20 45L21 46L20 45M182 45L183 46L182 45M22 46L23 47L22 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M182.333 46.6667L182.667 47.3333L182.333 46.6667M24 47L25 48L24 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M25 47L26 48L25 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M26 48L27 49L26 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M27 48L28 49L27 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M28 48L29 49L28 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M30 49L31 50L30 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M31 49L32 50L31 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M32 49L33 50L32 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M36 50L36 51L41 51L36 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M41 50L41 51L127 51L100 50L41 50M181 51L182 52L181 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M181.333 52.6667L181.667 53.3333L181.333 52.6667M126 55L127 56L126 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M126 56L127 57L126 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M180 56L181 57L180 56M126 57L127 58L126 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M180.333 57.6667L180.667 58.3333L180.333 57.6667M125 59L126 60L125 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M125 60L126 61L125 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M179 60L180 61L179 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M179.333 61.6667L179.667 62.3333L179.333 61.6667M124 62L125 63L124 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M124 63L125 64L124 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M178 64L179 65L178 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M123 65L124 66L123 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M178 65L179 66L178 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M122 67L123 68L122 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M177 67L178 68L177 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M177 68L178 69L177 68M121 69L122 70L121 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M177 69L178 70L177 69M120 70L121 71L120 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M120 71L121 72L120 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M176 71L177 72L176 71M119 72L120 73L119 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M176 72L177 73L176 72M118 73L119 74L118 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M175 73L176 74L175 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M175 74L176 75L175 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M117 75L118 76L117 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M116 76L117 77L116 76M174 76L175 77L174 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M115 77L116 78L115 77M174 77L175 78L174 77M114 78L115 79L114 78M113 79L114 80L113 79M173 79L174 80L173 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M172 81L173 82L172 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M110 83L111 84L110 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M171 83L172 84L171 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M109 84L110 85L109 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M171 84L172 85L171 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M108 85L109 86L108 85M170 85L171 86L170 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M170 86L171 87L170 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M169 87L170 88L169 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M103 89L104 90L103 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M168 89L169 90L168 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M102 90L103 91L102 90M101 91L102 92L101 91M167 91L168 92L167 91M100 92L101 93L100 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M166 92L167 93L166 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M99 93L100 94L99 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M166 93L167 94L166 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M98 94L99 95L98 94M165 94L166 95L165 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M97 95L98 96L97 95M164 95L165 96L164 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M164 96L165 97L164 96M94 97L95 98L94 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M163 97L164 98L163 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M93 98L94 99L93 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M162 98L163 99L162 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M92 99L93 100L92 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M91 100L92 101L91 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M161 100L162 101L161 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M90 101L91 102L90 101M160 101L161 102L160 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M89 102L90 103L89 102M159 102L160 103L159 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M86 104L87 105L86 104M158 104L159 105L158 104M85 105L86 106L85 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M157 105L158 106L157 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M84 106L85 107L84 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M156 106L157 107L156 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M83 107L84 108L83 107M82 108L83 109L82 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M155 108L156 109L155 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M81 109L82 110L81 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M154 109L155 110L154 109M79 110L80 111L79 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M153 110L154 111L153 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M78 111L79 112L78 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M152 111L153 112L152 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M77 112L78 113L77 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M151 112L152 113L151 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M76 113L77 114L76 113M75 114L76 115L75 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M74 115L75 116L74 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M149 115L150 116L149 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M73 116L74 117L73 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M148 116L149 117L148 116M147 117L148 118L147 117M70 118L71 119L70 118M146 118L147 119L146 118M69 119L70 120L69 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M145 119L146 120L145 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M68 120L69 121L68 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M144 120L145 121L144 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M67 121L68 122L67 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M143 121L144 122L143 121M66 122L67 123L66 122M142 122L143 123L142 122M65 123L66 124L65 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M141 123L142 124L141 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M64 124L65 125L64 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M140 124L141 125L140 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M63 125L64 126L63 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M139 125L140 126L139 125M62 126L63 127L62 126M138 126L139 127L138 126M61 127L62 128L61 127M137 127L138 128L137 127M60 128L61 129L60 128M136 128L137 129L136 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M135 129L136 130L135 129M134 130L135 131L134 130M133 131L134 132L133 131M132 132L133 133L132 132M131 133L132 134L131 133M130 134L131 135L130 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M129 135L130 136L129 135M128 136L129 137L128 136M127 137L128 138L127 137M126 138L127 139L126 138M125 139L126 140L125 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M121 142L122 143L121 142M45 143L46 144L45 143M120 143L121 144L120 143M44 144L45 145L44 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M119 144L120 145L119 144M43 145L44 146L43 145M118 145L119 146L118 145M42 146L43 147L42 146M117 146L118 147L117 146M41 147L42 148L41 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M116 147L117 148L116 147M40 148L41 149L40 148M115 148L116 149L115 148M39 149L40 150L39 149M114 149L115 150L114 149M38 150L39 151L38 150M113 150L114 151L113 150M112 151L113 152L112 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M36 153L37 154L36 153M109 153L110 154L109 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M35 154L36 155L35 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M108 154L109 155L108 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M34 155L35 156L34 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M107 155L108 156L107 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M33 156L34 157L33 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M106 156L107 157L106 156M105 157L106 158L105 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M32 158L33 159L32 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M104 158L105 159L104 158M31 159L32 160L31 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M103 159L104 160L103 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M30 160L31 161L30 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M102 160L103 161L102 160M29 161L30 162L29 161M101 161L102 162L101 161M100 162L101 163L100 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M28 163L29 164L28 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M27 164L28 165L27 164M26 165L27 166L26 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M25 167L26 168L25 167M24 168L25 169L24 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M23 169L24 170L23 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M22 171L23 172L22 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M21 172L22 173L21 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M20 174L21 175L20 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M19 175L20 176L19 175M87 175L88 176L87 175M86 176L87 177L86 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M18 177L19 178L18 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M85 177L86 178L85 177M17 178L18 179L17 178M84 178L85 179L84 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M17 179L18 180L17 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M83 179L84 180L83 179M16 180L17 181L16 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M82 180L83 181L82 180M81 181L82 182L81 181M15 182L16 183L15 182M80 182L81 183L80 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M79 183L80 184L79 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M14 184L15 185L14 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M13 185L14 186L13 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M13 186L14 187L13 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M77 186L78 187L77 186M12 187L13 188L12 187M76 187L77 188L76 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M12 188L13 189L12 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M75 188L76 189L75 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M11 189L12 190L11 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M74 189L75 190L74 189M11 190L12 191L11 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M10 191L11 192L10 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M10 192L11 193L10 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M72 192L73 193L72 192M9 193L10 194L9 193M71 193L72 194L71 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M9 194L10 195L9 194M70 194L71 195L70 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M8 196L9 197L8 196M68 197L69 198L68 197M7 198L8 199L7 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M67 198L68 199L67 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M7 199L8 200L7 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M6 200L7 201L6 200M66 200L67 201L66 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M6 201L7 202L6 201M65 201L66 202L65 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M5 203L6 204L5 203M64 203L65 204L64 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M5 204L6 205L5 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M63 204L64 205L63 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M4 206L5 207L4 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M62 206L63 207L62 206M4 207L5 208L4 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M61 208L62 209L61 208M3 209L4 210L3 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M60 209L61 210L60 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M3 210L4 211L3 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M60 210L61 211L60 210M59 212L60 213L59 212M2 213L3 214L2 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M2 214L3 215L2 214M58 214L59 215L58 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M58 216L58 217L148 217L120 216L58 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M148.667 216.333L149.333 216.667L148.667 216.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M150 216L150 217L154 217L150 216M1.33333 217.667L1.66667 218.333L1.33333 217.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M156 217L157 218L156 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M157.667 217.333L158.333 217.667L157.667 217.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M159.667 217.333L160.333 217.667L159.667 217.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M163 218L164 219L163 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M164 218L165 219L164 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M165.667 218.333L166.333 218.667L165.667 218.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M1 219L2 220L1 219M168 219L169 220L168 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M169 219L170 220L169 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M171 220L172 221L171 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M172 220L173 221L172 220M174 221L175 222L174 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M176 222L177 223L176 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M0 223L0 226L1 226L0 223M178 223L179 224L178 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M179 224L180 225L179 224M180 225L181 226L180 225M0 226L0 229L1 229L0 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M181 226L182 227L181 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M182 227L183 228L182 227M183 228L184 229L183 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M0 229L0 232L1 232L0 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M184 229L185 230L184 229M185 231L186 232L185 231M186 233L187 234L186 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M186 234L187 235L186 234M0 235L0 238L1 238L0 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M187 236L188 237L187 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M187.333 237.667L187.667 238.333L187.333 237.667M0.333333 238.667L0.666667 239.333L0.333333 238.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M187.333 239.667L187.667 240.333L187.333 239.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M0 240L0 243L1 243L0 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeff",
      stroke: "none"
    },
    d: "M0 243L0 268L188 268L188 248L187 248C180.949 268.371 154.938 267 138 267L52 267C38.9966 267 21.3708 268.565 10.0154 261.031C3.23209 256.53 3.00017 249.669 0 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M187.333 243.667L187.667 244.333L187.333 243.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M187.333 245.667L187.667 246.333L187.333 245.667M1 246L2 247L1 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M1.33333 247.667L1.66667 248.333L1.33333 247.667M187 247L188 248L187 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M2 250L3 251L2 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M186 250L187 251L186 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M2 251L3 252L2 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M185 252L186 253L185 252M3 253L4 254L3 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M184 254L185 255L184 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M4 255L5 256L4 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M183 255L184 256L183 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M5 257L6 258L5 257M6 258L7 259L6 258M7 259L8 260L7 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M179 259L180 260L179 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M8 260L9 261L8 260M178 260L179 261L178 260M10 261L11 262L10 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M176 261L177 262L176 261M12 262L13 263L12 262M174 262L175 263L174 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M14 263L15 264L14 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M15 263L16 264L15 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M171 263L172 264L171 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M172 263L173 264L172 263M17 264L18 265L17 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M18.6667 264.333L19.3333 264.667L18.6667 264.333M167 264L168 265L167 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M168.667 264.333L169.333 264.667L168.667 264.333M23 265L23 266L26 266L23 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M26 265L27 266L26 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M27 265L28 266L27 265M161 265L162 266L161 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M162 265L163 266L162 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M163.667 265.333L164.333 265.667L163.667 265.333M32 266L32 267L36 267L32 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M36.6667 266.333L37.3333 266.667L36.6667 266.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21b40",
      stroke: "none"
    },
    d: "M38.6667 266.333L39.3333 266.667L38.6667 266.333M151 266L152 267L151 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db586f",
      stroke: "none"
    },
    d: "M152 266L152 267L155 267L152 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e99eab",
      stroke: "none"
    },
    d: "M155 266L155 267L158 267L155 266z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZohoInitial);
export default __webpack_public_path__ + "static/media/zoho-initial.7a5a537a745534c179059509a893458b.svg";
export { ForwardRef as ReactComponent };